import { Component } from 'react'
import PropTypes from 'prop-types'

import theme from 'theme'
import Icon from 'components/Icon'

class PasswordRules extends Component {
  static propTypes = {
    passwordOutcome: PropTypes.array,
    theme: PropTypes.object
  }

  render() {
    return (
      <div css={{ textAlign: 'left', marginBottom: theme.space[5] }}>
        <div css={{ marginBottom: theme.space[2] }}>
          Please choose a password that meets all of the following:
        </div>
        <ul>
          {this.props.passwordOutcome.map(({ invalid, message }, i) => (
            <li
              key={i}
              css={{
                color: invalid ? theme.colors.steel[1] : theme.colors.blue[0],
                listStyleType: 'none',
                marginBottom: theme.space[1]
              }}
            >
              <Icon
                css={{
                  width: '0.6rem',
                  marginLeft: theme.space[1],
                  marginRight: theme.space[3],
                  color: invalid ? theme.colors.gray[1] : theme.colors.blue[0]
                }}
                icon={invalid ? 'close' : 'checkmark'}
              />
              {message}
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

export default PasswordRules
